import React, { useEffect, useRef } from 'react';
import StickyFill from 'stickyfilljs';
import './Sticky.scss';
import IStickyProps from './StickyProps';

const Sticky = ({ offset, render }: IStickyProps) => {
  const element = useRef<HTMLElement>();
  const attached = useRef(false);

  useEffect(() => {
    if (element.current && !attached.current) {
      StickyFill.add(element.current);
      element.current.classList.add('sticky-component');
      element.current.style.top = offset + 'px';
      attached.current = true;
    }
  }, [element]);

  useEffect(() => {
    return () => {
      if (element.current && attached.current) {
        StickyFill.remove(element.current);
        attached.current = false;
      }
    };
  }, []);

  return <>{render(element)}</>;
};

Sticky.defaultProps = {
  offset: 0,
};

export default Sticky;
